<template lang="pug">
.waiting-review-envelopes-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1.text-overflow-ellipse(style='width: 90%') {{ getEnvelopeName(item) }}
      .mb-1 {{ $t('waitingReviewEnvelopesCardTable.id') }}: {{ item.hashid }}
      .mb-1 {{ $t('waitingReviewEnvelopesCardTable.reviser') }}: {{ getEnvelopeReviser(item) }}
      .mb-0 {{ $t('waitingReviewEnvelopesCardTable.creationDate') }}: {{ item.created_at | dateTime }}
      template(v-if='$root.isMobile')
        button(
          :title='$t("waitingReviewEnvelopesCardTable.use")'
          data-bs-target='#new-envelope-mobile-modal'
          data-bs-toggle='modal'
          style='position: absolute; top: 0.75rem; right: 0.45rem'
          type='button'
        )
          icon(
            name='pen-to-square'
            v-tooltip:top='$t("waitingReviewEnvelopesCardTable.use")'
          )
      template(v-else)
        button(
          :title='$t("waitingReviewEnvelopesCardTable.use")'
          @click.stop='openDraft(item)'
          style='color: inherit; position: absolute; top: 0.75rem; right: 0.8rem'
          type='button'
        )
          icon(
            name='pen-to-square'
            v-tooltip:top='$t("waitingReviewEnvelopesCardTable.use")'
          ) 
      button(
        :title='$t("waitingReviewEnvelopesCardTable.changeVisibility")'
        @click.stop='openEditVisibilityModal(item)'
        style='position: absolute; bottom: 1rem; right: 0.5rem'
        type='button'
        v-if='availableVisibilities.length'
      )
        icon(
          name='eye'
          v-tooltip:top='$t("waitingReviewEnvelopesCardTable.changeVisibility")'
        )
    template(v-slot:table-head)
      th(style='width: 5%') {{ $t('waitingReviewEnvelopesCardTable.id') }}
      th(style='width: 30%') {{ $t('waitingReviewEnvelopesCardTable.name') }}
      th(style='width: 30%') {{ $t('waitingReviewEnvelopesCardTable.reviser') }}
      th(style='width: 30%')
        .d-flex
          span.text {{ $t('waitingReviewEnvelopesCardTable.creationDate') }}
          button(
            @click='addSort("created_at", "DESC")'
            style='margin-top: -2px'
            v-show='sort.created_at === "ASC"'
          )
            icon.icon--blue(name='angle-down')
          button(
            @click='addSort("created_at", "ASC")'
            style='margin-top: -2px'
            v-show='sort.created_at !== "ASC"'
          )
            icon.icon--blue(name='angle-up')
      th(style='width: 5%')
        span.text {{ $t('waitingReviewEnvelopesCardTable.actions') }}
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.hashid }}
      td
        .draft-envelopes-card-table__name.text-overflow-ellipse(
          :title='getEnvelopeName(item)'
        ) {{ getEnvelopeName(item) }}
      td {{ getEnvelopeReviser(item) }}
      td {{ item.created_at | dateTime }}
      td
        .d-flex
          template(v-if='$root.isMobile')
            button(
              :title='$t("waitingReviewEnvelopesCardTable.use")'
              @click.stop=''
              data-bs-target='#new-envelope-mobile-modal'
              data-bs-toggle='modal'
              type='button'
            )
              icon(
                name='pen-to-square'
                v-tooltip:top='$t("waitingReviewEnvelopesCardTable.use")'
              )
          template(v-else)
            button(
              :title='$t("waitingReviewEnvelopesCardTable.use")'
              @click.stop='openDraft(item)'
              style='color: inherit'
              type='button'
            )
              icon(
                name='pen-to-square'
                v-tooltip:top='$t("waitingReviewEnvelopesCardTable.use")'
              )
          button.ms-2(
            :class='{ "action--disabled": !canChangeVisibility(item) }'
            :disabled='!canChangeVisibility(item)'
            :title='$t("waitingReviewEnvelopesCardTable.changeVisibility")'
            @click.stop='openEditVisibilityModal(item)'
            type='button'
            v-if='availableVisibilities.length'
          )
            icon(
              name='eye'
              v-tooltip:top='$t("waitingReviewEnvelopesCardTable.changeVisibility")'
            )
  delete-envelope-modal(
    :envelope-id='selectedEnvelopeId'
    @refresh='$emit("item-deleted", selectedEnvelopeId)'
  )
  new-envelope-mobile-modal
  edit-visibility-modal(
    :visibilityOptions='visibilityOptionsForModal'
    :visibilitySelected='currentVisibilityValue'
    @change='handleVisibilityChange'
    ref='editVisibilityModal'
  )
  show-envelope-in-review-by-another-user-modal(
    :envelopeSender='envelopeSender'
    ref='showEnvelopeInReviewByAnotherUserModal'
  )
</template>
<script>
import EnvelopeState from '@/enums/EnvelopeState';
import RecipientState from '@/enums/RecipientState';
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EnvelopeSignaturesProgress from '@/ui/molecules/EnvelopeSignaturesProgress.vue';
import DeleteEnvelopeModal from '@/modules/business/components/organisms/modals/DeleteEnvelopeModal.vue';
import EditVisibilityModal from '@/modules/business/components/organisms/modals/EditVisibilityModal.vue';
import NewEnvelopeMobileModal from '@/modules/business/components/organisms/modals/NewEnvelopeMobileModal.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import TeamsService from '@/modules/account/services/http/TeamsService';
import {
  getAllowedVisibilities,
  getCurrentVisibilityValue,
  getVisibilityOptions,
} from '@/modules/business/common/envelopeVisibility';
import PermissionsService from '@/services/PermissionsService';
import ApiPermissions from '@/enums/ApiPermissions';
import alert from '@/modules/account/common/alert';
import ShowEnvelopeInReviewByAnotherUserModal from '@/modules/business/components/organisms/modals/ShowEnvelopeInReviewByAnotherUserModal.vue';

export default {
  name: 'WaitingReviewEnvelopesCardTable',
  components: {
    ShowEnvelopeInReviewByAnotherUserModal,
    Icon,
    IconStatus,
    CardTable,
    EnvelopeSignaturesProgress,
    DeleteEnvelopeModal,
    EditVisibilityModal,
    NewEnvelopeMobileModal,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      EnvelopeState,
      RecipientState,
      sort: {
        created_at: '',
      },
      selectedEnvelopeId: '',
      selectedEnvelope: null,
      teams: [],
      teamsLoaded: false,
    };
  },
  computed: {
    canReviewEnvelope() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.ENVELOPE_REVIEW_UPDATE
      );
    },
    canChangeEnvelopeVisibility() {
      return PermissionsService.isAdmin(this.$root.user);
    },
    availableVisibilities() {
      return getAllowedVisibilities(this.$store.state.organizations.selected);
    },
    visibilityOptionsForModal() {
      return getVisibilityOptions({
        visibilities: this.availableVisibilities,
        teams: this.teams,
        translate: (key) => this.$t(key),
      });
    },
    currentVisibilityValue() {
      return getCurrentVisibilityValue(this.selectedEnvelope);
    },
    envelopeSender() {
      return (
        this.selectedEnvelope?.sender?.name ??
        this.$t('waitingReviewEnvelopesCardTable.reviser')
      );
    },
  },
  methods: {
    addSort(column, type) {
      this.sort[column] = type;
      this.$emit('sort', {
        column: column,
        desc: type === 'DESC',
      });
    },

    checkNextOrderByColumnIsDesc(column) {
      if (column === this.sort.column) {
        return !this.sort.desc;
      }
      return false;
    },
    checkAccessReviewEnvelope(item) {
      return (
        this.canReviewEnvelope &&
        PermissionsService.isSenderSameLoggedUserOrWithoutReviser(
          this.$root.user,
          item.sender
        )
      );
    },
    async openDraft(item) {
      if (!this.checkAccessReviewEnvelope(item)) {
        this.selectedEnvelope = item;
        await this.$nextTick();
        this.$refs.showEnvelopeInReviewByAnotherUserModal.open();
        return;
      }
      this.$router.push(this.getRoute(item)).catch(() => {});
    },
    canChangeVisibility(item) {
      if (this.canChangeEnvelopeVisibility) {
        return true;
      }
      return PermissionsService.isSameUser(this.$root.user, item.creator);
    },
    async fetchTeams() {
      if (this.teamsLoaded || !this.availableVisibilities.includes('team')) {
        return;
      }
      try {
        const response = await TeamsService.list();
        this.teams = response.data.data;
        this.teamsLoaded = true;
      } catch {
        this.teams = [];
      }
    },
    async openEditVisibilityModal(item) {
      if (!this.canChangeVisibility(item)) {
        const action = this.$t(
          'waitingReviewEnvelopesCardTable.changeVisibility'
        );
        alert.fireAlert(this.$t('insufficientPermission', { action }), {
          classes: 'alert-warning',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      this.selectedEnvelope = item;
      await this.fetchTeams();
      await this.$nextTick();
      this.$refs.editVisibilityModal.open();
    },
    async handleVisibilityChange(payload) {
      if (!this.selectedEnvelope) {
        return;
      }
      this.$loading(true);
      try {
        await EnvelopesService.changeVisibility(
          this.selectedEnvelope.id,
          payload
        );
        this.$refs.editVisibilityModal.close();
        this.selectedEnvelope = null;
      } catch (error) {
        alert.fireAlert(
          `${this.$t('modal.envelope.sentEnvelopeError')} ${
            error.response?.data?.message ?? ''
          }`,
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          }
        );
        return;
      } finally {
        this.$loading(false);
      }
      this.$emit('refresh');
    },
    getRoute(item) {
      if (!this.checkAccessReviewEnvelope(item)) {
        this.$refs.showEnvelopeInReviewByAnotherUserModal.open();
        return;
      }
      return {
        name: 'business.envelope.recipients',
        params: {
          id: item.id,
        },
      };
    },
    getEnvelopeName(item) {
      return item.title && item.title !== 'old' ? item.title : item.subject;
    },
    getEnvelopeReviser(item) {
      return item.sender?.email
        ? item.sender.email
        : this.$t('signaturesList.envelopeStates.waiting-review');
    },
  },
};
</script>
<style lang="stylus">
.draft-envelopes-card-table__name
  max-width: 180px;
@media (min-width: 576px)
  .draft-envelopes-card-table__name
    max-width: 180px
@media (min-width: 768px)
  .draft-envelopes-card-table__name
    max-width: 180px
@media (min-width: 992px)
  .draft-envelopes-card-table__name
    max-width: 500px
@media (min-width: 1200px)
  .draft-envelopes-card-table__name
    max-width: 470px
@media (min-width: 1400px)
  .draft-envelopes-card-table__name
    max-width: 640px
.action--disabled
  cursor: not-allowed !important
  .icon
    opacity: .4
</style>
